import React from 'react';
import classNames from 'clsx';
// eslint-disable-next-line import/no-cycle
import {IconRebuilder} from '../IconRebuilder/IconRebuilder';
// eslint-disable-next-line import/no-cycle
import {SvgIcon} from '../SvgIcon/SvgIcon';

export interface IconProps {
  count?: number;
  s: {[key: string]: string};
  iconId: number;
  text?: string;
  containerHeight: number;
  containerWidth: number;
  aspectRatio?: number;
}

export const Icon1 = (props: IconProps) => (
  <SvgIcon viewBox="0 0 23 27.49" preserveAspectRatio={true} {...props}>
    <path d="M21.9861 25.32L20.2047 10.33C20.1136 9.57 19.4658 9 18.6966 9H17.067V12H16.0548V9H6.94522V12H5.93304V9H4.30344C3.53419 9 2.8864 9.57 2.7953 10.32L1.01388 25.32C0.953146 25.75 1.09485 26.18 1.37826 26.5C1.67179 26.82 2.08678 27 2.51189 27H20.4881C20.9132 27 21.3282 26.82 21.6217 26.5C21.9051 26.18 22.0469 25.75 21.9861 25.32Z" />
    <path d="M7 5.5C7 3.02 9.02 1 11.5 1C13.98 1 16 3.02 16 5.5V9H17V5.5C17 2.47 14.53 0 11.5 0C8.47 0 6 2.47 6 5.5V9H7V5.5Z" />
    {props.count !== undefined && (
      <text x="11.5" y="18" dy=".35em" textAnchor="middle" className={props.s.quantity} data-hook="items-count">
        {props.count}
      </text>
    )}
  </SvgIcon>
);

export const Icon1_old = (props: IconProps) => (
  <SvgIcon viewBox="5.7 0 105.5 126.1" preserveAspectRatio={true} {...props}>
    <path d="M99.8 28.4c0-1.2-0.9-2-2.1-2h-15c0 3.2 0 7.6 0 8.2 0 1.5-1.2 2.6-2.6 2.9 -1.5 0.3-2.9-0.9-3.2-2.3 0-0.3 0-0.3 0-0.6 0-0.9 0-4.7 0-8.2H40.1c0 3.2 0 7.3 0 8.2 0 1.5-1.2 2.9-2.6 2.9 -1.5 0-2.9-0.9-3.2-2.3 0-0.3 0-0.3 0-0.6 0-0.6 0-5 0-8.2h-15c-1.2 0-2 0.9-2 2L8.3 124c0 1.2 0.9 2.1 2.1 2.1h96.3c1.2 0 2.1-0.9 2.1-2.1L99.8 28.4z" />
    <path d="M59.1 5.9c-2.9 0-2 0-2.9 0 -2 0-4.4 0.6-6.4 1.5 -3.2 1.5-5.9 4.1-7.6 7.3 -0.9 1.8-1.5 3.5-1.8 5.6 0 0.9-0.3 1.5-0.3 2.3 0 1.2 0 2.1 0 3.2 0 1.5-1.2 2.9-2.6 2.9 -1.5 0-2.9-0.9-3.2-2.3 0-0.3 0-0.3 0-0.6 0-1.2 0-2.3 0-3.5 0-3.2 0.9-6.4 2-9.4 1.2-2.3 2.6-4.7 4.7-6.4 3.2-2.9 6.7-5 11.1-5.9C53.5 0.3 55 0 56.7 0c1.5 0 2.9 0 4.4 0 2.9 0 5.6 0.6 7.9 1.8 2.6 1.2 5 2.6 6.7 4.4 3.2 3.2 5.3 6.7 6.4 11.1 0.3 1.5 0.6 3.2 0.6 4.7 0 1.2 0 2.3 0 3.2 0 1.5-1.2 2.6-2.6 2.9s-2.9-0.9-3.2-2.3c0-0.3 0-0.3 0-0.6 0-1.2 0-2.6 0-3.8 0-2.3-0.6-4.4-1.8-6.4 -1.5-3.2-4.1-5.9-7.3-7.3 -1.8-0.9-3.5-1.8-5.9-1.8C61.1 5.9 59.1 5.9 59.1 5.9L59.1 5.9z" />
    {props.count !== undefined && (
      <text x="58.5" y="77" dy=".35em" textAnchor="middle" className={props.s.quantity} data-hook="items-count">
        {props.count}
      </text>
    )}
  </SvgIcon>
);

export const Icon2 = (props: IconProps) => (
  <SvgIcon viewBox="0 0 34.538 29" preserveAspectRatio={true} {...props}>
    <path d="M9.5 26.5C10.6046 26.5 11.5 25.6046 11.5 24.5C11.5 23.3954 10.6046 22.5 9.5 22.5C8.39543 22.5 7.5 23.3954 7.5 24.5C7.5 25.6046 8.39543 26.5 9.5 26.5Z" />
    <path d="M18.5 26.5C19.6046 26.5 20.5 25.6046 20.5 24.5C20.5 23.3954 19.6046 22.5 18.5 22.5C17.3954 22.5 16.5 23.3954 16.5 24.5C16.5 25.6046 17.3954 26.5 18.5 26.5Z" />
    <path d="M0 4.5H2.65C3.14 4.5 3.56 4.85 3.64 5.34L6.22 20.83C6.38 21.79 7.22 22.5 8.19 22.5H19" />
    <path d="M22.5 8V15.66C22.5 16.15 22.15 16.56 21.67 16.64L5.5 19.49" />
    {props.count !== undefined && (
      <text
        data-hook="items-count"
        className={classNames(props.s.quantity, props.s.withoutBackground)}
        textAnchor="middle"
        x="13"
        y="4"
        dy=".48em">
        {props.count}
      </text>
    )}
  </SvgIcon>
);

export const Icon2_old = (props: IconProps) => (
  <SvgIcon viewBox="0 0 197.7 166" preserveAspectRatio={true} {...props}>
    <path d="M197.9 55.9L169.9 127.4 64.5 127.4 27.6 29.8 0 29.8 0.2 16.7 36.5 16.7 73.4 114.3 160.9 114.3 183 55.9"></path>
    <circle cx="143.8" cy="153" r="13"></circle>
    <circle cx="90.8" cy="153" r="13"></circle>
    {props.count !== undefined && (
      <text
        data-hook="items-count"
        className={classNames(props.s.quantity, props.s.withoutBackground)}
        textAnchor="middle"
        x="116"
        y="35"
        dy=".48em">
        {props.count}
      </text>
    )}
  </SvgIcon>
);

export const Icon3 = (props: IconProps) => (
  <IconRebuilder
    initialViewBoxWidth={120}
    initialViewBoxHeight={105}
    text={props.text}
    aspectRatio={props.aspectRatio!}>
    {({width, height, textRef, textLength}) => (
      <SvgIcon viewBox={`0 0 ${width} ${height}`} preserveAspectRatio={true} {...props}>
        <g data-hook="movable" transform={`translate(${textLength})`}>
          <circle className={props.s.bubble} cx="70" cy="50" r="50" />
          {props.count !== undefined && (
            <text x="70" y="50%" dy=".32em" textAnchor="middle" className={props.s.quantity} data-hook="items-count">
              {props.count}
            </text>
          )}
        </g>
        <text x="0" y="50%" dy=".35em" ref={textRef} data-hook="free-text">
          {props.text}
        </text>
      </SvgIcon>
    )}
  </IconRebuilder>
);

// eslint-disable-next-line sonarjs/no-identical-functions
export const Icon3_old = (props: IconProps) => (
  <IconRebuilder
    initialViewBoxWidth={120}
    initialViewBoxHeight={105}
    text={props.text}
    aspectRatio={props.aspectRatio!}>
    {/* eslint-disable-next-line sonarjs/no-identical-functions */}
    {({width, height, textRef, textLength}) => (
      <SvgIcon viewBox={`0 0 ${width} ${height}`} preserveAspectRatio={true} {...props}>
        <g data-hook="movable" transform={`translate(${textLength})`}>
          <circle className={props.s.bubble} cx="70" cy="50" r="50" />
          {props.count !== undefined && (
            <text x="70" y="50%" dy=".32em" textAnchor="middle" className={props.s.quantity} data-hook="items-count">
              {props.count}
            </text>
          )}
        </g>
        <text x="0" y="50%" dy=".35em" ref={textRef} data-hook="free-text">
          {props.text}
        </text>
      </SvgIcon>
    )}
  </IconRebuilder>
);

export const Icon4 = (props: IconProps) => {
  return (
    <IconRebuilder
      initialViewBoxWidth={145}
      initialViewBoxHeight={105}
      text={props.text}
      count={props.count}
      aspectRatio={props.aspectRatio!}>
      {({width, height, textRef}) => (
        <SvgIcon viewBox={`0 0 ${width} ${height}`} preserveAspectRatio={true} {...props}>
          <text x="0" y="83" ref={textRef} data-hook="free-text">
            {`${props.text!} `}
            {props.count !== undefined && (
              <tspan className={classNames(props.s.quantity, props.s.withoutBackground)} data-hook="items-count">
                ({props.count})&rlm;
              </tspan>
            )}
          </text>
        </SvgIcon>
      )}
    </IconRebuilder>
  );
};

// eslint-disable-next-line sonarjs/no-identical-functions
export const Icon4_old = (props: IconProps) => {
  return (
    <IconRebuilder
      initialViewBoxWidth={145}
      initialViewBoxHeight={105}
      text={props.text}
      count={props.count}
      aspectRatio={props.aspectRatio!}>
      {/* eslint-disable-next-line sonarjs/no-identical-functions */}
      {({width, height, textRef}) => (
        <SvgIcon viewBox={`0 0 ${width} ${height}`} preserveAspectRatio={true} {...props}>
          <text x="0" y="83" ref={textRef} data-hook="free-text">
            {`${props.text!} `}
            {props.count !== undefined && (
              <tspan className={classNames(props.s.quantity, props.s.withoutBackground)} data-hook="items-count">
                ({props.count})&rlm;
              </tspan>
            )}
          </text>
        </SvgIcon>
      )}
    </IconRebuilder>
  );
};

export const Icon5 = (props: IconProps) => (
  <IconRebuilder
    initialViewBoxWidth={315}
    initialViewBoxHeight={129}
    aspectRatio={props.aspectRatio!}
    text={props.text}>
    {({width, height, textRef, textLength}) => (
      <SvgIcon viewBox={`0 0 ${width} ${height}`} preserveAspectRatio={true} {...props}>
        <g transform="scale(4.78)">
          <path d="M10.458 24.5C11.5626 24.5 12.458 23.6046 12.458 22.5C12.458 21.3954 11.5626 20.5 10.458 20.5C9.35344 20.5 8.45801 21.3954 8.45801 22.5C8.45801 23.6046 9.35344 24.5 10.458 24.5Z"></path>
          <path d="M19.458 24.5C20.5626 24.5 21.458 23.6046 21.458 22.5C21.458 21.3954 20.5626 20.5 19.458 20.5C18.3534 20.5 17.458 21.3954 17.458 22.5C17.458 23.6046 18.3534 24.5 19.458 24.5Z" />
          <path d="M6.95801 7.5H23.118C23.788 7.5 24.268 8.15 24.078 8.79L21.888 16.08C21.638 16.93 20.858 17.51 19.968 17.51H10.988C10.078 17.51 9.28801 16.9 9.05801 16.03L5.65801 3.24C5.53801 2.8 5.14801 2.5 4.68801 2.5H1.95801" />
        </g>
        <text x="174" y="95" ref={textRef} data-hook="free-text">
          {props.text}
        </text>
        <g data-hook="movable" transform={`translate(${textLength})`}>
          {props.count !== undefined && (
            <text
              x="202"
              y="95"
              textAnchor="start"
              className={classNames(props.s.quantity, props.s.withoutBackground)}
              data-hook="items-count">
              {props.count}
            </text>
          )}
        </g>
      </SvgIcon>
    )}
  </IconRebuilder>
);

export const Icon5_old = (props: IconProps) => (
  <IconRebuilder
    initialViewBoxWidth={315}
    initialViewBoxHeight={129}
    aspectRatio={props.aspectRatio!}
    text={props.text}>
    {({width, height, textRef, textLength}) => (
      <SvgIcon viewBox={`0 0 ${width} ${height}`} preserveAspectRatio={true} {...props}>
        <path d="M70.9 128.6c-8.3 0-15.5-7.1-15.5-15.5s7.1-15.5 15.5-15.5 15.5 7.1 15.5 15.5-7.1 15.5-15.5 15.5zm0-20.8c-3 0-5.4 2.4-5.4 5.4s2.4 5.4 5.4 5.4 5.4-2.4 5.4-5.4-2.4-5.4-5.4-5.4zM115.3 128.7c-8.3 0-15.5-7.1-15.5-15.5s7.1-15.5 15.5-15.5 15.5 7.1 15.5 15.5-7.1 15.5-15.5 15.5zm0-20.8c-3 0-5.4 2.4-5.4 5.4s2.4 5.4 5.4 5.4 5.4-2.4 5.4-5.4-2.4-5.4-5.4-5.4z"></path>
        <path d="M135.1 88.1L51.2 88.1 22 10.1 0 10.1 0 0 29.1 0 58.6 78.1 127.7 78.1 145.8 29.1 36.9 29.1 33.3 19 160.7 19z"></path>
        <text x="184" y="95" ref={textRef} data-hook="free-text">
          {props.text}
        </text>
        <g data-hook="movable" transform={`translate(${textLength})`}>
          {props.count !== undefined && (
            <text
              x="212"
              y="95"
              textAnchor="start"
              className={classNames(props.s.quantity, props.s.withoutBackground)}
              data-hook="items-count">
              {props.count}
            </text>
          )}
        </g>
      </SvgIcon>
    )}
  </IconRebuilder>
);

export const Icon6 = (props: IconProps) => (
  <SvgIcon viewBox="0 0 68.636 28" preserveAspectRatio={false} {...props}>
    <g transform="scale(0.175) translate(-40, 10)">
      <path
        className={props.s.bubble}
        d="M281.6 3c35.7 10.7 56 47.6 45.2 83.3s-47.6 56-83.3 45.2c-35.7-10.7-56-47.6-45.2-83.3C209 13.1 245.9-7.2 281.6 3z"
      />
    </g>

    {props.count !== undefined && (
      <text x="39" y="13" dy=".35em" textAnchor="middle" className={props.s.quantity} data-hook="items-count">
        {props.count}
      </text>
    )}
    <g id="Layer_1" clipPath="url(#clip0_133_1520)">
      <path
        id="Vector"
        d="M8.87964 24.6699C9.98421 24.6699 10.8796 23.7745 10.8796 22.6699C10.8796 21.5654 9.98421 20.6699 8.87964 20.6699C7.77507 20.6699 6.87964 21.5654 6.87964 22.6699C6.87964 23.7745 7.77507 24.6699 8.87964 24.6699Z"
      />
      <path
        id="Vector_2"
        d="M17.8796 24.6699C18.9842 24.6699 19.8796 23.7745 19.8796 22.6699C19.8796 21.5654 18.9842 20.6699 17.8796 20.6699C16.7751 20.6699 15.8796 21.5654 15.8796 22.6699C15.8796 23.7745 16.7751 24.6699 17.8796 24.6699Z"
      />
      <path
        id="Vector_3"
        d="M5.37964 7.66992H21.5396C22.2096 7.66992 22.6896 8.31992 22.4996 8.95992L20.3096 16.2499C20.0596 17.0999 19.2796 17.6799 18.3896 17.6799H9.40964C8.49964 17.6799 7.70964 17.0699 7.47964 16.1999L4.07964 3.40992C3.95964 2.96992 3.56964 2.66992 3.10964 2.66992H0.379639"
      />
    </g>
  </SvgIcon>
);

export const Icon6_old = (props: IconProps) => (
  <SvgIcon viewBox="0 0 329.7 134.5" preserveAspectRatio={false} {...props}>
    <path
      className={props.s.bubble}
      d="M281.6 3c35.7 10.7 56 47.6 45.2 83.3s-47.6 56-83.3 45.2c-35.7-10.7-56-47.6-45.2-83.3C209 13.1 245.9-7.2 281.6 3z"></path>
    {props.count !== undefined && (
      <text x="265" y="69" dy=".35em" textAnchor="middle" className={props.s.quantity} data-hook="items-count">
        {props.count}
      </text>
    )}
    <path d="M74.1 134.4c-8.7 0-16.2-7.4-16.2-16.2S65.3 102 74.1 102s16.2 7.4 16.2 16.2-7.4 16.2-16.2 16.2zm0-21.7c-3.1 0-5.6 2.5-5.6 5.6s2.5 5.6 5.6 5.6 5.6-2.5 5.6-5.6-2.5-5.6-5.6-5.6zM120.5 134.5c-8.7 0-16.2-7.4-16.2-16.2s7.4-16.2 16.2-16.2 16.2 7.4 16.2 16.2-7.4 16.2-16.2 16.2zm0-21.7c-3.1 0-5.6 2.5-5.6 5.6s2.5 5.6 5.6 5.6c3.1 0 5.6-2.5 5.6-5.6s-2.5-5.6-5.6-5.6z"></path>
    <path d="M141.2 92.1L53.5 92.1 23 10.6 0 10.6 0 0 30.4 0 61.2 81.6 133.5 81.6 152.4 30.4 38.5 30.4 34.8 19.9 167.9 19.9z"></path>
  </SvgIcon>
);

export const Icon7 = (props: IconProps) => (
  <IconRebuilder
    initialViewBoxWidth={140}
    initialViewBoxHeight={200}
    text={props.text}
    aspectRatio={props.aspectRatio!}>
    {({width, height, textLength, textRef}) => (
      <SvgIcon viewBox={`0 0 ${width} ${height}`} preserveAspectRatio={false} {...props}>
        <g data-hook="movable" transform={`translate(${textLength})`}>
          <path
            className={props.s.bubble}
            d="M88.7 4.121c-35.7-10.7-73.2 10.1-83.3 45.2 -5.4 17.9-2.4 36.9 6 51.8l-7.7 26.2 25-6c6.5 5.4 14.3 8.9 22.6 11.3 35.7 10.7 73.2-10.1 83.3-45.2C144.6 51.721 124.4 14.221 88.7 4.121z"
          />
          {props.count !== undefined && (
            <text x="70" y="70" dy=".35em" textAnchor="middle" className={props.s.quantity} data-hook="items-count">
              {props.count}
            </text>
          )}
        </g>
        <text x="0" y="178" data-hook="free-text" ref={textRef}>
          {props.text}
        </text>
      </SvgIcon>
    )}
  </IconRebuilder>
);

// eslint-disable-next-line sonarjs/no-identical-functions
export const Icon7_old = (props: IconProps) => (
  <IconRebuilder
    initialViewBoxWidth={140}
    initialViewBoxHeight={200}
    text={props.text}
    aspectRatio={props.aspectRatio!}>
    {/* eslint-disable-next-line sonarjs/no-identical-functions */}
    {({width, height, textLength, textRef}) => (
      <SvgIcon viewBox={`0 0 ${width} ${height}`} preserveAspectRatio={false} {...props}>
        <g data-hook="movable" transform={`translate(${textLength})`}>
          <path
            className={props.s.bubble}
            d="M88.7 4.121c-35.7-10.7-73.2 10.1-83.3 45.2 -5.4 17.9-2.4 36.9 6 51.8l-7.7 26.2 25-6c6.5 5.4 14.3 8.9 22.6 11.3 35.7 10.7 73.2-10.1 83.3-45.2C144.6 51.721 124.4 14.221 88.7 4.121z"
          />
          {props.count !== undefined && (
            <text x="70" y="70" dy=".35em" textAnchor="middle" className={props.s.quantity} data-hook="items-count">
              {props.count}
            </text>
          )}
        </g>
        <text x="0" y="178" data-hook="free-text" ref={textRef}>
          {props.text}
        </text>
      </SvgIcon>
    )}
  </IconRebuilder>
);

export const Icon8 = (props: IconProps) => (
  <SvgIcon viewBox="0 0 47.755 22" preserveAspectRatio={false} {...props}>
    <path d="M6.13962 8.65811L9.02566 0L9.97434 0.316228L7.19371 8.65811H14.8063L12.0257 0.316228L12.9743 0L15.8604 8.65811H22V9.65811H20.9336L19.2832 19.5702C19.083 20.7714 18.0344 21.6581 16.82 21.6581H5.20001C3.97413 21.6581 2.93675 20.77 2.73681 19.5703L1.08638 9.65811H0V8.65811H6.13962ZM2.10015 9.65811L3.72321 19.4059C3.7232 19.4059 3.72321 19.4059 3.72321 19.4059C3.8433 20.1262 4.46591 20.6581 5.20001 20.6581H16.82C17.5456 20.6581 18.177 20.1248 18.2968 19.406C18.2968 19.406 18.2968 19.406 18.2968 19.406L19.9199 9.65811H2.10015ZM6 18.6581V11.6581H7V18.6581H6ZM9 18.6581V11.6581H10V18.6581H9ZM12 18.6581V11.6581H13V18.6581H12ZM15 18.6581V11.6581H16V18.6581H15Z" />
    {props.count !== undefined && (
      <text
        x="25"
        y="21"
        textAnchor="start"
        className={classNames(props.s.quantity, props.s.withoutBackground)}
        data-hook="items-count">
        {props.count}
      </text>
    )}
  </SvgIcon>
);

export const Icon8_old = (props: IconProps) => (
  <SvgIcon viewBox="221.4 359.3 267 123" preserveAspectRatio={false} {...props}>
    <rect x="221.4" y="403.7" width="152.4" height="6" />
    <path d="M345.9 482.3h-96.4c-1.2 0-2.4-1.2-3-2.4l-19.6-70.8 6-1.8 19.1 68.5h92.3l19-68.5 6 1.8 -19.6 70.8C348.2 481.1 347 482.3 345.9 482.3z" />
    <rect
      x="259"
      y="380.1"
      transform="matrix(-0.527 -0.8498 0.8498 -0.527 109.9867 827.3946)"
      width="52.4"
      height="6"
    />
    <rect x="292.3" y="424.5" width="10.7" height="10.7" />
    <rect x="315.5" y="424.5" width="10.7" height="10.7" />
    <rect x="269.1" y="424.5" width="10.7" height="10.7" />
    <rect x="292.3" y="447.7" width="10.7" height="10.7" />
    <rect x="315.5" y="447.7" width="10.7" height="10.7" />
    <rect x="269.1" y="447.7" width="10.7" height="10.7" />
    {props.count !== undefined && (
      <text
        x="390"
        y="474"
        textAnchor="start"
        className={classNames(props.s.quantity, props.s.withoutBackground)}
        data-hook="items-count">
        {props.count}
      </text>
    )}
  </SvgIcon>
);

export const Icon9 = (props: IconProps) => (
  <SvgIcon viewBox="0 0 21.83 26" preserveAspectRatio={true} {...props}>
    {props.count !== undefined && (
      <text
        x="11.5"
        y="17.5"
        dy=".35em"
        textAnchor="middle"
        className={classNames(props.s.quantity, props.s.withoutBackground)}
        data-hook="items-count">
        {props.count}
      </text>
    )}
    <path d="M19.214 25.175H3.78603C3.31103 25.175 2.91203 24.8235 2.84553 24.3485L1.19253 8.1985C1.11653 7.6285 1.56303 7.125 2.13303 7.125H20.867C21.437 7.125 21.8835 7.6285 21.8075 8.1985L20.164 24.3485C20.0975 24.8235 19.6985 25.175 19.2235 25.175H19.214Z" />
    <path d="M16.25 10.4499V5.22485C16.25 2.60285 14.122 0.474854 11.5 0.474854C8.878 0.474854 6.75 2.60285 6.75 5.22485V10.4499" />
  </SvgIcon>
);

export const Icon9_old = (props: IconProps) => (
  <SvgIcon viewBox="0 0 164.9 196.4" preserveAspectRatio={true} {...props}>
    {props.count !== undefined && (
      <text
        x="84"
        y="131"
        dy=".35em"
        textAnchor="middle"
        className={classNames(props.s.quantity, props.s.withoutBackground)}
        data-hook="items-count">
        {props.count}
      </text>
    )}
    <path d="M81.9 11.5c-18.8 0-34.1 16-34.1 35.7v18.1h7.8V47.2c0-15.4 11.8-27.9 26.4-27.9 14.5 0 26.4 12.5 26.4 27.9v18.1h6.6V64h1.1V47.2c-.1-19.7-15.4-35.7-34.2-35.7z"></path>
    <path d="M156.9 70.5v118H8v-118h148.9m8-8H0v134h164.9v-134z"></path>
  </SvgIcon>
);

export const Icon10 = (props: IconProps) => (
  <SvgIcon viewBox="0 0 44.933 30" preserveAspectRatio={true} {...props}>
    <path d="M20.5 16.66H15.86L12.97 8L12.02 8.32L14.8 16.66H7.19L9.97 8.32L9.02 8L6.13 16.66H0V17.66H1.08L2.73 27.57C2.93 28.78 3.97 29.66 5.19 29.66H16.81C18.03 29.66 19.07 28.78 19.27 27.57L20.92 17.66H22V16.66H20.5ZM16 19.66V26.66H15V19.66H16ZM13 19.66V26.66H12V19.66H13ZM10 19.66V26.66H9V19.66H10ZM7 19.66V26.66H6V19.66H7Z" />{' '}
    <g transform="scale(0.15) translate(-175, -325)">
      <path
        className={props.s.bubble}
        d="M383.4 334c35.7 10.7 56 47.6 45.2 83.3 -10.7 35.7-47.6 56-83.3 45.2 -35.7-10.7-56-47.6-45.2-83.3C310.7 344.2 348.2 323.9 383.4 334z"
      />
    </g>
    {props.count !== undefined && (
      <text x="28.5" y="11" dy=".35em" textAnchor="middle" className={props.s.quantity} data-hook="items-count">
        {props.count}
      </text>
    )}
  </SvgIcon>
);

export const Icon10_old = (props: IconProps) => (
  <SvgIcon viewBox="163.7 331.4 267.8 178.8" preserveAspectRatio={true} {...props}>
    <path d="M243.4 425.1l-29.7-47.9 -9.1 5.6 26.2 42.2h-67.1v10.7h3l19.1 70.2c0.6 2.4 3 4.2 5.4 4.2h97c2.4 0 4.2-1.8 4.2-3.6l19.6-70.8h4.2v-10.7H243.4zM221.4 473.3v10.7h-10.7V473.3H221.4zM210.7 461.4v-10.7h10.7v10.7H210.7zM244.7 473.3v10.7h-10.7V473.3H244.7zM233.9 461.4v-10.7h10.7v10.7H233.9zM257.8 484V473.3h10.7v10.7H257.8zM268.5 461.4h-10.7v-10.7h10.7V461.4z" />
    <path
      className={props.s.bubble}
      d="M383.4 334c35.7 10.7 56 47.6 45.2 83.3 -10.7 35.7-47.6 56-83.3 45.2 -35.7-10.7-56-47.6-45.2-83.3C310.7 344.2 348.2 323.9 383.4 334z"
    />
    {props.count !== undefined && (
      <text x="365" y="400" dy=".35em" textAnchor="middle" className={props.s.quantity} data-hook="items-count">
        {props.count}
      </text>
    )}
  </SvgIcon>
);

export const Icon11 = (props: IconProps) => (
  <SvgIcon viewBox="0 0 136 134.5" preserveAspectRatio={true} {...props}>
    <path
      d="M87.1 3c35.7 10.7 56 47.6 45.2 83.3s-47.6 56-83.3 45.2C13.3 120.8-7 83.9 3.8 48.2 14.5 13.1 51.4-7.2 87.1 3z"
      className={props.s.bubble}></path>
    {props.count !== undefined && (
      <text x="70" y="70" dy=".35em" className={props.s.quantity} data-hook="items-count" textAnchor="middle">
        {props.count}
      </text>
    )}
  </SvgIcon>
);

// eslint-disable-next-line sonarjs/no-identical-functions
export const Icon11_old = (props: IconProps) => (
  <SvgIcon viewBox="0 0 136 134.5" preserveAspectRatio={true} {...props}>
    <path
      d="M87.1 3c35.7 10.7 56 47.6 45.2 83.3s-47.6 56-83.3 45.2C13.3 120.8-7 83.9 3.8 48.2 14.5 13.1 51.4-7.2 87.1 3z"
      className={props.s.bubble}></path>
    {props.count !== undefined && (
      <text x="70" y="70" dy=".35em" className={props.s.quantity} data-hook="items-count" textAnchor="middle">
        {props.count}
      </text>
    )}
  </SvgIcon>
);
